import { QueryFunction } from '@tanstack/react-query';
import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';
import { IncomeType } from './types';

export interface GetIncomeTypesParams {
  inUse?: boolean;
}

const getIncomeTypes: QueryFunction<
  IncomeType[],
  ['/income-types', GetIncomeTypesParams?]
> = async ({ queryKey }) => {
  const params = queryKey[1];
  if (isMockServices()) return await mock(_mockIncomeTypes(params?.inUse));

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<{
    success: boolean;
    data: IncomeType[];
  }>(
    params?.inUse !== undefined
      ? `/income-types?inUse=${params.inUse}`
      : '/income-types',
    { method: 'GET' },
  );

  return response.data?.data ?? [];
};

export default getIncomeTypes;

const _mockIncomeTypes = (inUse?: boolean): IncomeType[] => {
  const all: IncomeType[] = [
    {
      id: 'it-w2',
      type: 'W-2 Employment Income',
      documents: [
        { documentTypeId: 'ygi2fbkim9bb7jgwtvsq24f2', count: 2 },
        { documentTypeId: 'gpmzc1p5ye939v8kbzigoccc', count: 1 },
      ],
      formJson: {
        version: 1,
        createForm: { sections: [] },
        analysisForm: {
          streamForm: { title: 'Prorated Income Data' },
          analysisPanel: { title: 'Income Analysis' },
        },
      },
      inUse: true,
    },
    {
      id: 'it-1099',
      type: '1099 Services Income',
      documents: [],
      formJson: {},
      inUse: false,
    },
  ];
  return inUse === undefined ? all : all.filter((t) => t.inUse === inUse);
};
